import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from 'app/provider/providerManager';
import {validateFields, validateField} from './../../../utilities/validation/validator';
import lodash from 'lodash';

export const initiate = createAsyncThunk('routeractivationwizardblock/initiate', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('initiateRouterActivationWizard', [data.EquipmentId]);
    if (result.Body.header.returnCode === '00') {
      return {RequestId: result.Body.body.response.requestId};
    }
    throw 'error';
  } catch (error) {
    return error;
  }
});

export const setNextWizardStep = createAsyncThunk('routeractivationwizardblock/setNextWizardStep', async (data, thunkAPI) => {
  if (data && data.RequestId && data.RequestId != '') {
    const setStepRequest = {
      requestId: data.RequestId,
      dataType: data.Step.dataType,
      inputValue: data.Step.inputValue,
      stepData: JSON.stringify(data.StepData),
    };

    const result = await ProviderManager.getProviderData('setRouterActivationWizardStep', setStepRequest);

    if (result.Header.ReturnCode == 0) {
      thunkAPI.dispatch(getWizardStep(data));
    }
  }
});

const setIntervalAsync = async (data, thunkAPI) => {
  return new Promise((resolve, reject) => {
    let counter = 0;
    let timerId = setInterval(
      () => {
        if (counter++ > 215) {
          clearInterval(timerId);
          reject('Timeout expired');
        }

        ProviderManager.getProviderData('getRouterActivationWizardStep', [data.RequestId])
          .then((result) => {
            if (result && result.Body && result.Body.outputCode1 && result.Header.ReturnCode == 0) {
              clearInterval(timerId);
              resolve({
                Step: result.Body.outputCode1.toLowerCase(),
                PrevStep: data.CurrentStep,
                StepData: result.Body.outputData,
                DataType: result.Body.stepInputDataType,
                InputValue: result.Body.stepReleaseSuccessActionCode,
              });
            }
            if (result.Header.ReturnCode != 0) {
              clearInterval(timerId);
              reject('Wizard exception');
            }
          })
          .catch((error) => {
            clearInterval(timerId);
            reject('Wizard exception');
          });
      },
      data.Timeout ? data.Timeout : 2000,
    );
  });
};

export const getWizardStep = createAsyncThunk('routeractivationwizardblock/getWizardStep', async (data, thunkAPI) => {
  if (data && data.RequestId && data.RequestId != '') {
    return await setIntervalAsync(data, thunkAPI);
  }
});

const routerActivationWizardBlockSlice = createSlice({
  name: 'routeractivationwizardblock',
  initialState: {
    currentStep: 'ready',
    prevStep: '',
    steps: ['ready', 'predefine', 'update', 'definenetwork', 'error', 'generalerror'],
    wizardRequestId: '',
    step: {
      dataType: '',
      inputValue: '',
      stepData: '',
    },
    form: {
      network: '',
      netPassword: '',
      valid: '',
      errors: {
        network: '',
        netPassword: '',
      },
      ispUser: '',
      ispPassword: '',
      rules: {
        network: {
          required: {value: true, error: 'אנא בחר שם רשת'},
        },
        netPassword: {
          required: {value: true, error: 'אנא בחר סיסמא'},
          minLength: {value: 8, error: 'יש להזין לפחות 8 תווים'},
        },
      },
    },
    networkDefinitionProcessing: false,
  },
  reducers: {
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    clearIsValid: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.valid = '';
        return {payload: form};
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    setNetworkDefinitionProcessing: {
      reducer(state, action) {
        state.networkDefinitionProcessing = action.payload;
      },
      prepare(payload) {
        return {payload: payload};
      },
    },
  },
  extraReducers: {
    [initiate.fulfilled]: (state, action) => {
      if (
        (action.payload.errorCode && action.payload.errorCode !== '00') ||
        (action.payload.message &&
          (action.payload.message.toLowerCase().includes('error') || action.payload.message.toLowerCase().includes('timeout')))
      ) {
        state.currentStep = 'error';
      } else {
        const {RequestId} = action.payload;
        state.wizardRequestId = RequestId;
      }
      return state;
    },
    [setNextWizardStep.fulfilled]: (state, action) => {
      if (!action.payload) return state;

      if (
        (action.payload.errorCode && action.payload.errorCode !== '00') ||
        (action.payload.message &&
          (action.payload.message.toLowerCase().includes('error') || action.payload.message.toLowerCase().includes('timeout')))
      ) {
        state.currentStep = 'error';
      }

      return state;
    },
    [getWizardStep.fulfilled]: (state, action) => {
      if (!action.payload) return state;

      const {Step, PrevStep, StepData, DataType, InputValue} = action.payload;
      if (
        (action.payload.errorCode && action.payload.errorCode !== '00') ||
        (action.payload.message &&
          (action.payload.message.toLowerCase().includes('error') || action.payload.message.toLowerCase().includes('timeout')))
      ) {
        alert(action.payload.errorCode + ':' + action.payload.message);
        state.currentStep = 'error';
        state.PrevStep = PrevStep;
      } else {
        state.currentStep = Step;
        state.prevStep = PrevStep;
        state.step.stepData = StepData;
        state.step.dataType = DataType;
        state.step.inputValue = InputValue;

        if (StepData != null && StepData !== '') {
          const data = JSON.parse(StepData);
          if (data.ispUser != '' && data.ispPassword != '') {
            state.form.ispUser = data.ispUser;
            state.form.ispPassword = data.ispPassword;
          }
        }
      }
      return state;
    },
    [getWizardStep.rejected]: (state, action) => {
      state.currentStep = 'error';
    },
  },
});

export const {changeHandler, clearIsValid, validateHandler, extractUserIspData, setNetworkDefinitionProcessing} =
  routerActivationWizardBlockSlice.actions;

export default routerActivationWizardBlockSlice.reducer;
